import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import useConfiguration from "../../hooks/useConfiguration";
import useSessionStorage from "../../hooks/useSessionStorage";
import DataGrid from "../common/DataGrid";
import Header from "../common/Header";
import Loader from "../common/Loader";
import Modal from "../common/Modal/modal";
import Sidebar from "../common/Sidebar";
import DeleteModal from "../common/Modal/DeleteGridModal";
import { editPost, resetJobOpportunityInfo, setJobId } from "../JobOpportunity/action";
import {
    updateJobId
} from '../JobOpportunity/Summary/action';
import {
    firstPage, gotoPage, lastPage, loadJobListings, loadMasterDatas, nextPage, previousPage,
    setPageSize, updateSort,deleteJob
} from "./action";
import GPSInfo from "./GPSInfo";
import './index.css';
import JobFilter from "./jobFilter";
import { createHeaders, createPageData } from "./jobUtilities";
import Messaging from "./Messaging";
import { jobListingSelector } from './selector';
import GridDelete from "./GridDelete";
const showView = true;

// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
    const navigate = useNavigate();
    const [openGps, setOpenGps] = useState({
        show: false,
        jobData: undefined
    });
    const [deletedata, setdeletedata] = useState({
        show: false,
        jobId: undefined
    });
    const [openMessaging, setOpenMessaging] = useState({
        open: false,
        jobId: undefined
    });
    const headers = createHeaders();
    const dispatch = useDispatch();
    const config = useConfiguration();
    const storage = useSessionStorage();
    const login = storage.getItem('login');
    const { data, pageSize, page } = useSelector(jobListingSelector);
    const empId = login.employerUniqueId;
    const url = config.baseUrl;
    const AppuseridValue = login.appUserId;
    const [show, setShow] = useState(false);
    const [showDelete, setShowDelete] = useState(false);
    const [deleteId, setDeleteId] = useState('');
        
    useEffect(() => {
        if (config.baseUrl) {
            dispatch(loadMasterDatas(config.baseUrl, empId)).then(() => {
                dispatch(loadJobListings({ url, empId }));
            })
        }
    }, [config]);
    const gotoFirstPage = () => {
        dispatch(firstPage()).then(() => {
            dispatch(loadJobListings());
        });
    }
    const gotoNextPage = () => {
        dispatch(nextPage()).then(() => {
            dispatch(loadJobListings({ url, empId }));
        });
    }
    const gotoPreviousPage = () => {
        dispatch(previousPage()).then(() => {
            dispatch(loadJobListings({ url, empId }));
        });
    }
    const gotoLastPage = () => {
        dispatch(lastPage()).then(() => {
            dispatch(loadJobListings({ url, empId }));
        });
    }
    const gotoSelectedPage = (page) => {
        dispatch(gotoPage(page)).then(() => {
            dispatch(loadJobListings({ url, empId }));
        });
    }
    const updatePageSize = (size) => {
        dispatch(setPageSize(size)).then(() => {
            dispatch(loadJobListings({ url, empId }));
        });
    }
    const generateRowData = (data, headers) => {
        const rowData = {};
        headers.forEach(header => {
            if (header.type === 'text') {
                if (typeof header.field === 'array') {
                    rowData[header.name] = header.field.map(fld => data[fld]).join(" ");
                } else {
                    rowData[header.name] = data[header.field]
                }
            } else {
                if (header.field === 'isClaimed') {
                    const isClaimed = data[header.field];
                    const iconClass = isClaimed ? 'green-icon' : 'grey-icon'
                    rowData[header.name] = {
                        type: 'icon',
                        class: `fa fa-check-circle icon-align ${iconClass}`
                    }
                }
                if (header.field === 'isCheckedIn') {
                    const isCheckedIn = data[header.field];
                    const iconClass = isCheckedIn ? 'fa-check-circle green-icon' : 'fa-times-circle red-icon'
                    rowData[header.name] = {
                        type: 'icon',
                        class: `fa icon-align ${iconClass}`
                    }
                }
                if (header.field === 'isCheckedOut') {
                    const isCheckedOut = data[header.field];
                    const iconClass = isCheckedOut ? 'fa-check-circle green-icon' : 'fa-times-circle red-icon'
                    rowData[header.name] = {
                        type: 'icon',
                        class: `fa icon-align ${iconClass}`
                    }
                }
                if (header.field === 'isPaid') {
                    const isPaid = data[header.field];
                    const iconClass = isPaid ? 'green-icon fa-check-circle' : 'fa-times-circle red-icon'
                    rowData[header.name] = {
                        type: 'icon',
                        class: `fa icon-align ${iconClass}`
                    }
                }
                if (header.field === 'edit') {
                    rowData[header.name] = {
                        type: 'icon',
                        class: `fa fa-pencil icon-align`,
                        onClick: () => {
                            editJob(data['jobUniqueId'])
                        }
                    }
                }
                if (header.field === 'matching') {

                    rowData[header.name] = {

                        type: 'icon',

                        class: `icon-align fa fa-file`,

                        onClick: () => {

                            matchingCandidate(data['jobUniqueId'])

                        }

                    }

                }
                if (header.field === 'view') {
                    rowData[header.name] = {
                        type: 'icon',
                        class: `icon-align fa fa-file`,
                        onClick: () => {
                            viewJob(data['jobUniqueId'])
                        }
                    }
                }
                if (header.field === 'delete') {
                    rowData[header.name] = {
                        type: 'icon',
                        class: `icon-align fe fe-trash-2 fa-lg`,
                        onClick: () => {
                            showDeletedata(data['jobUniqueId']) 
                        }
                    }
                }
                if (header.field === 'message') {
                    rowData[header.name] = {
                        type: 'icon',
                        class: `icon-align fa fa-commenting`,
                        onClick: () => {
                            setOpenMessaging({
                                open: true,
                                jobId: data['jobUniqueId']
                            });
                        }
                    }
                }
                if (header.field === 'ratings') {
                    rowData[header.name] = {
                        type: 'ratings',
                        value: data[header.field]
                    }
                }
                if (header.name === 'Approval') {
                    rowData[header.name] = data[header.field].map(fld => {
                        const isSuccess = fld.isApproved;
                        const iconClass = isSuccess ? 'green-icon fa-check-circle' : 'fa-times-circle red-icon'
                        return {
                            type: 'icon',
                            class: `fa icon-align ${iconClass}`
                        }
                    });
                }
                if (header.field === 'gpsTrackingStatus') {
                    const gpsStatus = data['gpsTrackingStatus'];
                    const showIcon = true;//gpsStatus !== 0 && gpsStatus !== 3;
                    const iconClass = (gpsStatus === 1 || gpsStatus === 0 || gpsStatus === 3) ? 'green-icon' : gpsStatus === 2 ? 'yellow-icon' : 'red-icon'
                    if (showIcon) {
                        rowData[header.name] = {
                            type: 'icon',
                            class: `icon-align fa fa-map-marker ${iconClass}`,
                            onClick: () => {
                                showHideGps(data);
                            }
                        }
                    }
                }
            }
        });
        return rowData;
    }
    const formatTableData = (data) => {
        const tableData = {
            headers,
            rows: data?.jobShifts?.map(data => ({
                columns: generateRowData(data, headers)
            })),
            options: {
                sortable: false,
                filter: false,
                pagination: true,
                pageSize: pageSize || 10
            },
            pageData: createPageData(page, pageSize, data?.totalCount),
            firstPage: gotoFirstPage,
            nextPage: gotoNextPage,
            previousPage: gotoPreviousPage,
            lastPage: gotoLastPage,
            updatePageSize: updatePageSize,
            gotoPage: gotoSelectedPage,
            headerComponentParams: {
                sort: (order, column) => {
                    dispatch(updateSort(order, column)).then(() => {
                        dispatch(loadJobListings({ url, empId }));
                    });
                },
                headers
            }
        }
        return tableData;
    }

    const viewJob = (jobId) => {       
        dispatch(updateJobId(jobId, "/joblist")).then(() => {
            navigate("/jobsummary", {
                state: {
                    jobUniqueId: jobId,
                    gotoMatching: true,
                    save: false
                }
            });
        });
    }

    const deleteshiftJob = (jobId) => {
        const params = {
            "JobUniqueId": jobId           
        }
        dispatch(deleteJob({ url: `${config.baseUrl}/Jobs/delete-job-details`, params })).then(() => {
            dispatch(loadJobListings({ url, empId }));
        })
    }

    const matchingCandidate = (jobId) => {

        navigate("/matchingcandidate", {

            state: {

                matchingJobid: jobId

            }

        });

    }

    const editJob = (jobId) => {
        dispatch(resetJobOpportunityInfo()).then(() => {
            dispatch(editPost()).then(() => {
                dispatch(setJobId(jobId)).then(() => {
                    navigate("/jobopportunity");
                });
            })
        })
    }

    const cancelJobView = () => {
        dispatch(updateJobId(undefined)).then(() => {
            navigate("/joblist");
        });
    }

    const showHideGps = (jobData) => {
        if (jobData && jobData.jobUniqueId) {
            setOpenGps({
                show: true,
                jobData: jobData
            })
        } else {
            setOpenGps({
                show: false,
                jobData: undefined
            });
        }
    }

    const handleClose = () => setShow(false);
    const handleClosefalse = () => {
        setdeletedata({
            show: false
        })
    }
    const handleDeleteData = () => {     
      
        const params = {
            "JobUniqueId": deleteId,
            "AppUserId" : AppuseridValue           
        }  
        dispatch(deleteJob({ url: `${config.baseUrl}/Jobs/delete-job-details`, params })).then(() => {
            dispatch(loadJobListings({ url, empId }));
        })
        setdeletedata({
            show: false
        })
    }
    
    
    const showDeletedata = (jobId) => {
        setDeleteId(jobId)
        console.log(setDeleteId,jobId);
        if (jobId) {
            setdeletedata({
                show: true,
                jobId: jobId
            })
        } else {
            setdeletedata({
                show: false,
                jobId: undefined
            });
        }          
    }

    return <div className="page main-margin">
        <Loader />
        <Header />
        <Sidebar />
        <div className="page-main">
            <div className="main-content app-content mt-0 main-background">
                <div className="side-app">
                    <div className="main-container container-fluid">
                        <div className="page-header">
                            <h1 className="page-title">List Shift Opportunities</h1>
                        </div>
                        <div className="card">
                            {
                                openGps.show && <Modal label={"GPS"} onlyClose={true} showHide={showHideGps}>
                                    <GPSInfo {...openGps.jobData} show={openGps.show} />
                                </Modal>
                            }                            
                            {deletedata.show &&
                              <DeleteModal  showDelete={true} handleDeleteClose={handleClosefalse} handleDelete={handleDeleteData} />
                             }
                            <div className="card-body">
                                <div className="row">
                                    <div className='col-lg-12 col-md-12'>
                                        <JobFilter />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xl-12 col-md-12 col-lg-12">
                                <div className="card">
                                    <div className="card-body">
                                        <DataGrid {...formatTableData(data)} />
                                        {
                                            <div className="message-overlay">
                                                {openMessaging.open && <Messaging jobId={openMessaging.jobId} closeChatWindow={() => {
                                                    setOpenMessaging({
                                                        open: false,
                                                        jobId: undefined
                                                    })
                                                }}/>}
                                                
                                            </div>
                                        }                                     
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
}
